import ModalCloseButton from 'components/buttons/ModalCloseButton'
import React, { useRef } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import styled from 'styled-components'
import { setViewSendQuickMessageModal, setQuickMessageData, sendQuickMessage } from 'features/posts/postSlice'
import { imgUrl } from 'features/constants';
import SendIcon from '@mui/icons-material/Send';
import { BsSendCheckFill } from "react-icons/bs";
import { pBtn } from 'components/main.styled'
import { useTranslation } from 'react-i18next'


export default function SendQuickMessageModal() {
    const { t } = useTranslation('messaging')

    const dispatch = useDispatch()
    const { quickMessageData, quickMessageStatus } = useSelector( (state) => state.posts)
    const messageRef = useRef( null )

    const handleSendMessage = () => { 
        dispatch(sendQuickMessage({
            receiverUserType: quickMessageData.userType,
            receiverId: quickMessageData.userId,
            message: document.querySelector('textarea').value
        }))
    }

    return (
        <SendQuickMessageModalContainer> 
            <ModalCloseButton
                size='40px'
                top="15px"
                right='15px'
                handler={
                    () =>  {
                        dispatch(setQuickMessageData({
                            userId: '',
                            fullName: '',
                            profileImage: '',
                        }))
                        dispatch(setViewSendQuickMessageModal(false))
                        
                    }
                }
                /> 

            {
                quickMessageStatus === 'error' ? 
                (
                    <div>{t('errors.quickSendFailed')}</div>
                )
                : quickMessageStatus === 'success' ?
                (
                    <SuccessContainer> 
                        <BsSendCheckFill 
                            style={{
                                fontSize: '50px', 
                                color: 'green', 
                                marginBottom: '20px',
                                // spin animation only 1 rotation
                                animation: 'spin .5s linear'
                                }} 
                                />
                        <span> 
                            {t('quickMessage.sentTo', { name: quickMessageData.fullName })}
                        </span>  
                    </SuccessContainer>
                )
                : (quickMessageStatus === 'idle' || quickMessageStatus === 'loading') &&  
                ( 
                    <FormContainer>
                        <Recipient> 
                            <span> 
                                {t('quickMessage.to')}
                            </span>
                            <span
                                style={
                                    {
                                        marginTop: '10px',
                                        display: 'flex',
                                        flexDirection: 'row',
                                        alignItems: 'center'
                                    }
                                }
                                >
                                <RecipientImage
                                    alt={t('quickMessage.recipientImage')}
                                    src={quickMessageData.profileImage}
                                    />  
                            
                                {quickMessageData.fullName}
                            </span>
                        </Recipient>

                        <MessageEntryContainer> 
                            <MessageEntry
                                ref={messageRef}
                                placeholder={t('quickMessage.placeholder')}
                                rows="5"
                                />
                        </MessageEntryContainer>

                        <BtnContainer>
                            <SendBtn 
                                disabled={quickMessageStatus === 'loading' ? true : false}
                                onClick={handleSendMessage}
                                > 
                                <SendIcon />
                                {
                                    quickMessageStatus === 'loading' ? t('quickMessage.sending') : t('quickMessage.send')
                                }
                            </SendBtn>
                        </BtnContainer> 
                    </FormContainer>
                )
            }
        </SendQuickMessageModalContainer>
    )
}

const SuccessContainer = styled.div`
    display: flex;
    width: 100%;
    height: 100%;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`

const FormContainer = styled.div` 
    width: 100%;
    height: 100%;
`

const BtnContainer = styled.div`
    margin-top: 20px;
    width: 100%; 
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    justify-content: flex-end;

`

const SendBtn = styled(pBtn)` 
    pointer-events: ${props => props.disabled ? 'none' : 'auto'};
    background-color: var(--themeColor);
    color: white;
    font-size: 12px;
    &:hover {
        background-color: #0d6efd;
    }
`

const Recipient = styled.div`
    margin-top: 20px;
    display: flex;
    flex-direction: column;
    margin-bottom: 20px; 
`

const RecipientImage = styled.img`
    width: 45px;
    height: 45px;
    border-radius: 45px;
    margin-right: 10px;
`

const MessageEntryContainer = styled.div`
    display: flex;
    flex-direction: column;
    min-height: 50%; 
    width: 100%; 
`



const MessageEntry = styled.textarea`
    outline: none;
    border: none;
    padding: 20px;
    height: 150px;
    font-family: Arial, Helvetica, sans-serif;
    resize: none;
    width: 100%;
    border-radius: 20px;
    background-color: aliceblue;

`
const SendQuickMessageModalContainer = styled.div`
    width: 600px;
    height: 400px;
    display: flex;
    border-radius: 10px;
    flex-direction: column;
    align-items: flex-start;
    background-color: white;
    justify-content: flex-start;
    padding: 20px;
    color: var(--lightThemeFontColor);
    position: relative;
`
